(function () {
  angular.module(
    "akitabox.core.ui.dialogs.workOrder.create.locationSection",
    []
  );
})();
